import mirror from 'keymirror';
import Library from '../lib/library';

export const actionTypes = mirror({
  ONBOARDING_GET_PATHS_ERROR: null,
  ONBOARDING_GET_PATHS_IN_PROGRESS: null,
  ONBOARDING_GET_PATHS_SUCCESS: null,
});

const onboardingGetError = error => ({
  error,
  type: actionTypes.ONBOARDING_GET_PATHS_ERROR,
});

const onboardingGetInProgress = () => ({
  type: actionTypes.ONBOARDING_GET_PATHS_IN_PROGRESS,
});

const onboardingGetSuccess = results => ({
  results,
  type: actionTypes.ONBOARDING_GET_PATHS_SUCCESS,
});

export const getOnboardingPathList = () => async dispatch => {
  try {
    dispatch(onboardingGetInProgress());
    const list = await Library.getPathOnboarding();
    dispatch(onboardingGetSuccess(list));
  } catch (err) {
    dispatch(onboardingGetError(err));
  }
};
